import React from 'react';
import './ManagementCard.css';
import ManagementCardContent from './ManagementCardContent';

const ManagementCard = (props) => {
    return (
        <div className="management-card card">
            <h3 className="management-card-title">{props.title}</h3>
            {props.methods.map((method, index) => (
                <ManagementCardContent setIsLoading={props.setIsLoading} setModal={props.setModal} method={method} href={props.href_list[index]} name={props.name_list[index]}/>
            ))}
        </div>
    );
};

export default ManagementCard;
